<iframe
  id="unthread_help_center"
  style="
    width: 100%;
    height: 100%;
    border: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
  "
></iframe>
